import React                            from 'react';
import { Observe }                      from 'rewire-core';
import SettingsModel                    from './SettingsModel';
import { Theme, makeStyles }            from '../utility/styles';
import {
  DefaultEditPanelView,
}                                       from './DefaultSettingsView';
import { IInfoPanelProps }              from '../ui/InfoPanel';
import ArchiveDeleteEmployeeDialog      from './ArchiveDeleteEmployeeDialog';

const useEmployeeEditPanelViewStyles = makeStyles((_theme: Theme) => ({
  infoPanelRoot: {
  },
}));

const EmployeeEditPanelView = ({ settings, classes, InfoPanelProps }: { settings: SettingsModel, classes?: any, InfoPanelProps?: IInfoPanelProps }) => {
  const employeeEditPanelClasses = useEmployeeEditPanelViewStyles({classes});
  return <Observe render={() => (
    <>
    <DefaultEditPanelView InfoPanelProps={InfoPanelProps} settings={settings} classes={employeeEditPanelClasses} />
    <ArchiveDeleteEmployeeDialog />
    </>
  )} />;
};

EmployeeEditPanelView.defaultProps = {
  InfoPanelProps: {
    defaultSize: {
      width: 450,
      height: '100%',
    },
    minWidth: 450,
  }
};

export default EmployeeEditPanelView;